<div #zawartosc class="zawartosc" matTooltip="{{tooltip}}" [ngClass]="{'dwa-wiersze': liczbaWierszy===2,'trzy-wiersze':liczbaWierszy===3}"
     matTooltipClass="tooltip-legenda2">
    <ng-content></ng-content>
  <div #zawartoscPomiarowa class="zawartosc-pomiarowa">
  </div>
</div>

